/**
 * Created by Jerker Nord on 2018-05-31.
 */
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {Timeline, TimelineLite, TweenLite} from "gsap";

export interface ITractorBeamStickySymbol {
    symbolPosition:PIXI.Point;
    symbol:TractorBeamStickySymbol;
}

export class TractorBeamStickySymbol extends PIXI.Container {

    private _stickySymbolName:string;
    private _symbol:PIXI.Sprite;

    private _symWinLoop:TimelineSprite | null;

    constructor(stickySymbolName:string, isPanelSym:boolean = false) {
        super();
        this._stickySymbolName = stickySymbolName;
        this._symbol = new PIXI.Sprite(GameResources.getTextures("panelSym-" + stickySymbolName)[0]);
        this._symbol.anchor.set(0.5, 0.5);

        if(isPanelSym) {

            // Create sym win loop
            if(["W"].indexOf(this.stickySymbolName) < 0) {
                if(this._stickySymbolName.indexOf("L") > -1) {
                    this.createSymWinLoop(0.65);
                } else {
                    this.createSymWinLoop(((this._stickySymbolName === "M1") ? 0.95 : undefined));
                }
            }

            this.addChild(this._symbol);

        }
    }

    private createSymWinLoop(scale:number = 0.85):void {
        const tls:TimelineSprite = new TimelineSprite(GameResources.getTextures("symWinLoop"));
        tls.anchor.set(0.5, 0.5);
        tls.scale.set(scale, scale);
        tls.name = "symWinLoop";
        tls.blendMode = PIXI.BLEND_MODES.ADD;
        //tls.playLoop();
        tls.hide();
        this._symWinLoop = tls;
        //this._symWinLoop.playLoop();
        this.addChildAt(this._symWinLoop, 0);
    }

    public playSymWin():Timeline {
        const tl:TimelineLite = new TimelineLite();

        if(this._symWinLoop) {
            tl.add([
                () => {
                    if(this._symWinLoop) {
                        this._symWinLoop.getAnimationAutoShowHide();
                    }
                },
                TweenLite.fromTo(this._symWinLoop, this._symWinLoop.totalDuration, {alpha : 1}, {alpha : 0})
            ]);
        }

        return tl;
    }

    public get stickySymbolName():string {
        return this._stickySymbolName;
    }

    public symbolTint(value:any) {
        this._symbol.tint = value;
    }
}
